import * as apis from '@/api';
import { typeRate } from '@/tool';


export const roll_rooms = {
	namespaced: true,


	state: {
		/** 首页Roll房 */
		home_roll_rooms: [],

		/** 首页Roll房 分页 */
		home_roll_rooms_pager: {
			page: 1,
			category: 2,
			page_size: 2,
			total: 0,
		},
	},


	getters: {
		home_roll_rooms(state) {
			return state.home_roll_rooms;
		},

		home_roll_rooms_pager(state) {
			const { total, page_size } = { ...state.home_roll_rooms_pager };
			const pages = parseInt(total / page_size) + ((total % page_size) > 0 ? 1 : 0);

			return {
				...state.home_roll_rooms_pager,
				pages: pages || 1
			};
		},
	},


	mutations: {
		/** 设置 首页Roll房 */
		SET_ROLL_ROOMS(state, payload) {
			state.home_roll_rooms = payload.data;
		},

		/** 设置 首页Roll房 分页 */
		SET_ROLL_ROOMS_PAGER(state, payload) {
			state.home_roll_rooms_pager = payload.data;
		},
	},


	actions: {
		/** 刷新首页Roll房 */
		async refresh_home_roll_rooms(
			{ commit, dispatch, getters },
			{ delay } = { delay: 1000 * 10 }
		) {
			commit('SET_ROLL_ROOMS_PAGER', { data: {
				...getters.home_roll_rooms_pager,
				page: 1,
			} });

			dispatch('get_home_roll_rooms', {
				...getters.home_roll_rooms_pager
			});


			let lock = false;
			const interval_id = window.setInterval(async () => {
				if (lock) return;

				const page = getters.home_roll_rooms_pager.page <  getters.home_roll_rooms_pager.pages
					? getters.home_roll_rooms_pager.page + 1
					: 1;

				commit('SET_ROLL_ROOMS_PAGER', { data: {
					...getters.home_roll_rooms_pager,
					page,
				} });

				lock = true;
				await dispatch('get_home_roll_rooms', {
					...getters.home_roll_rooms_pager
				});
				lock = false;
			}, delay);


			return () => {
				window.clearInterval( interval_id );
			};
		},

		/** 获取Roll房 */
		async get_home_roll_rooms({ commit, getters }, {
			page, category, page_size
		} = { page: 1, category: 2, page_size: 2 }) {
			const roll_rooms_response = await apis.roll_list({
				type: category, size:page_size
			});

			let roll_rooms_data = roll_rooms_response.data.data;

			// 填充数据
			const fill_roll_rooms_number =
				page === getters.home_roll_rooms_pager.pages
					? page_size - roll_rooms_data.length
					: 0
			;
			let fill_roll_rooms_data = []
			if (fill_roll_rooms_number) {
				const fill_roll_rooms_response = await apis.roll_list({
					type: category, count: fill_roll_rooms_number
				});

				fill_roll_rooms_data = fill_roll_rooms_response.data.data;
			}
			roll_rooms_data = roll_rooms_data.concat(fill_roll_rooms_data);

			const roll_rooms = roll_rooms_data.map( (roll_room) => ({
				...roll_room,
				Items: roll_room.Items
			}) );

			commit('SET_ROLL_ROOMS', { data: roll_rooms });

			commit('SET_ROLL_ROOMS_PAGER', { data: {
				...getters.home_roll_rooms_pager,
				page: roll_rooms_response.data.data.pageNumber,
				total: roll_rooms_response.data.data.totalItems,
			} });
		}
	}
};
